// pollyfill promise & object.assign
import 'core-js/fn/promise'
import 'core-js/fn/object/assign'

import axios from 'axios'
import Vue from 'vue'
import Modal from './VueComponents/modal.vue'
import CartTimer from './VueComponents/cart-timer.vue'

import { formatMoney } from 'accounting-js'
import { AxiosRedirectIntercepted } from './errors'

const setAxiosHeaderToIndicateRequestIsAnAjaxOne = () => {
    // set this header so we can detect on the server if this is an ajax request
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
}

const setAxiosToInterceptRedirectsAndThrow = () => {
    axios.interceptors.response.use(response => {
        const redirectUrl = response && response.data && response.data.redirect
        if (redirectUrl) {
            window.location = redirectUrl
            // we throw an error here to break through any promise then's
            // straight to the catch
            throw new AxiosRedirectIntercepted()
        }

        return response
    })
}


const setAxiosHeaderToAspAntiForgeryToken = () => {
    axios.interceptors.request.use(config => {
        if(config.method && config.method.toLowerCase() == "post")
    {
        const aspnetAntiForgeryToken = document.getElementsByName(
            '__RequestVerificationToken',
        )

        if (aspnetAntiForgeryToken.length === 0) {
            throw new Error('Could not find anti forgery token: input[name=__RequestVerificationToken] was not found');
        } else {
            config.headers.common['RequestVerificationToken'] = aspnetAntiForgeryToken[0].value
        }
    }
    return config
})
}

const addCurrencyFilterGloballyToVue = () => {
    Vue.filter('currency', value => {
        if (value === '-') return value
        return formatMoney(value, '$', 2, ',', ',')
    })
}

const addGlobalComponentsToVue = () => {
    Vue.component('modal', Modal)
    Vue.component('cart-timer', CartTimer)
}

setAxiosHeaderToIndicateRequestIsAnAjaxOne()
setAxiosToInterceptRedirectsAndThrow()
setAxiosHeaderToAspAntiForgeryToken()
addCurrencyFilterGloballyToVue()
addGlobalComponentsToVue()



// WEBPACK FOOTER //
// ./Features/Shared/common.js